import { DataItemProps } from "apis";
import { FieldItemProps } from "apis/field";
import { lazy } from "react";

export const PageAdminData = lazy(() => import("./List"));
export const PageAdminDataForm = lazy(() => import("./Form"));
// export const PageAdminFormUpdate = lazy(() => import("./Edit"));

export interface FormDataValuesProps extends Omit<DataItemProps, "id"> {
    id?: number;
    [key: string]: any
}

export type OperatorType = "=" | "!=" | "like" | "<" | ">" | "<=" | ">=" | "in";

/**
 *  lt → <
 *  lte → <=
 *  gt → >
 *  gte → >=
 */

export const operators: OperatorType[] = ["=", "!=", "like"];
export type FilterType = {
    fieldCode: string;
    operator: OperatorType;
    value: string;
}

export const reconvert = (search: string, fields: FieldItemProps[]): { q: string; filters: FilterType[] } => {
    const filters: FilterType[] = [];
    let q = "";

    // 1. Bỏ dấu "?" đầu
    const queryString = search.startsWith("?") ? search.slice(1) : search;

    // 2. Split từng cặp theo "&" để giữ thứ tự
    const pairs = queryString.split("&");

    for (const pair of pairs) {
        if (!pair) continue;

        const [rawKey, rawValue] = pair.split("=");
        const key = decodeURIComponent(rawKey);
        const value = decodeURIComponent(rawValue || "");

        if (key === "q") {
            q = value;
            continue;
        }

        // match dạng: field[]=
        const directMatch = key.match(/^([^[]+)\[\]$/);
        if (directMatch) {
            const fieldCode = directMatch[1];
            if (fields.findIndex(f => f.code === fieldCode) >= 0) {
                filters.push({ fieldCode, operator: "=", value });
            }
            continue;
        }

        // match dạng: prefix[field][]
        const nestedMatch = key.match(/^([a-z]+)\[([^[]+)\]\[\]$/);
        if (nestedMatch) {
            const prefix = nestedMatch[1]; // not, lt, lte, gt, gte, like
            const fieldCode = nestedMatch[2];

            let operator: FilterType["operator"] = "=";
            if (prefix === "not") operator = "!=";
            else if (prefix === "like") operator = "like";
            else if (prefix === "lt") operator = "<";
            else if (prefix === "lte") operator = "<=";
            else if (prefix === "gt") operator = ">";
            else if (prefix === "gte") operator = ">=";

            if (fields.findIndex(f => f.code === fieldCode) >= 0) {
                filters.push({ fieldCode, operator, value });
            }
        }
    }

    return { q, filters };
}

export const convert = (filters: FilterType[], q: string) => {
    let search: string = "";
    filters.map(filter => {
        switch (filter.operator) {
            case "=":
                search += `${filter.fieldCode}[]=${filter.value}&`;
                break;
            case "!=":
                search += `not[${filter.fieldCode}][]=${filter.value}&`;
                break;
            case "<":
                search += `lt[${filter.fieldCode}][]=${filter.value}&`;
                break;
            case "<=":
                search += `lte[${filter.fieldCode}][]=${filter.value}&`;
                break;
            case ">":
                search += `gt[${filter.fieldCode}][]=${filter.value}&`;
                break;
            case ">=":
                search += `gte[${filter.fieldCode}][]=${filter.value}&`;
                break;
            case "like":
                search += `like[${filter.fieldCode}][]=${filter.value}&`;
                break;
            default: break;
        }
    })
    search += `q=${q || ""}`;
    return search;
}